import {
    apiGetHelper,
    apiPostFormHelper,
    apiPostHelper,
    apiGetCurrency,
    apiGetParamsHelper,
    apiPutHelper,
    apiDeleteHelper
} from 'utils/apiHelper'
import { appPrefix, getCookie } from 'utils/browserHelper'
import { DOMAIN, HOSTNAME, ANALYTICS_DOMAIN, CT_ENV, ORIGIN_DOMAIN } from 'constants/base'
import logError from 'utils/logError'
import { setSentryError } from 'utils/logError'
import { DOMAIN_COUNTRY_MAP } from 'constants/domainConfig'
import axios from 'axios'

export const flightResultsGetApi = queryParam => {
    //const URL = 'https://api.myjson.com/bins/rh8uc'
    //const URL = 'http://localhost:3000/twoway.json'
    //const URL = 'http://localhost:3000/intlRT.json'
    //  const URL = 'https://api.myjson.com/bins/107oac'
    // const URL = 'https://api.myjson.com/bins/107oac'
    // const URL = 'https://api.myjson.com/bins/d79r8'
    // const URL = 'http://localhost:7000/'
    // const URL = `http://localhost:9000/node/flight/search?from=BLR&to=DXB&adults=1&childs=0&infants=0&class=Economy&airline=&carrier=&ver=V2&type=json&intl=y&search_ver=V2&depart_date=21/01/2020&return_date=26/01/2020`
    // const URL = `http://localhost:9000/node/flight/search?${queryParam}`
    // const URL = `http://localhost:9000/node/flight/search?from=BLR&to=BOM&depart_date=05/02/2020&adults=1&childs=0&infants=0&class=Economy&airline=&carrier=&intl=n&sd=1579492307926&page=loaded`

    // TODO: remove the commented out url
    // const URL =
    //     '/flight/search?trip_type=OneWay&from=DEL&to=VGA&depart_date=04/12/2019&adults=1&childs=0&infants=0&class=Economy&airline=&carrier=&ver=V2&type=json&intl=n&search_ver=V2'
    // const URL = '/book/flightsmisc/v2/getInsurance?itinerary-id=6854806d67-a7bb-40cc-97fc-191126151341'

    // const URL = `${DOMAIN}/flights/results/airjson?trip_type=OneWay&origin=Bangalore%2C+IN+-+Bengaluru+International+Airport+(BLR)&from=BLR&destination=Mumbai%2C+IN+-+Chatrapati+Shivaji+Airport+(BOM)&to=BOM&depart_date=24%2F12%2F2019&adults=1&childs=0&infants=0&class=Economy&airline=&carrier=&ver=V2&type=json&intl=n&sd=1574763412590&page=&search_ver=V2&cc=1&rhc=1&timeout=3000`
    //  const URL =     'http://localhost:3031/flights/results/airjson?trip_type=OneWay&origin=Bangalore%2C+IN+-+Bengaluru+International+Airport+(BLR)&from=BLR&destination=Mumbai%2C+IN+-+Chatrapati+Shivaji+Airport+(BOM)&to=BOM&depart_date=24%2F12%2F2019&adults=1&childs=0&infants=0&class=Economy&airline=&carrier=&ver=V2&type=json&intl=n&sd=1574763412590&page=&search_ver=V2&cc=1&rhc=1&timeout=3000'

    const URL = `${DOMAIN}/node/flight/search?${queryParam}`
    const response = apiGetHelper(URL)
    return response
}

export const travelSafeBannerStatusSRP = (oa, da, oc, dc) => {
    const URL = `${DOMAIN}/node/flight/travelsafe/route?oc=${oc}&dc=${dc}&oa=${oa}&da=${da}`
    const response = apiGetHelper(URL)
    return response
}
export const travelSafeData = url => {
    const URL = `${DOMAIN}${url}`
    const response = apiGetHelper(URL)
    return response
}

export const airportSearch = string => {
    let URL = `${DOMAIN}/places/airports/search?string=${string}`
    if (getCookie('lp') === 'ar' && appPrefix === '/ar') {
        URL = `${DOMAIN}/ar/suggest/airports?expectedNumberOfRecords=10&outputLanguages=ARABIC&inputText=${string}`
    }
    const response = apiGetHelper(URL)
    return response
}
export const airLineSearch = string => {
    let URL = `${DOMAIN}/flights/airlines/search?string=${string}`
    const response = apiGetHelper(URL)
    return response
}

export const getCurrenciesApi = () => {
    const timestamp = new Date()
        .toISOString()
        .split('T')[0]
        .split('-')
        .join('') //YYYYMMDD
    const URL = `${process.env.CT_PUBLIC_CURRENCY_ENDPOINT}?ts=${timestamp}`

    const response = apiGetCurrency(URL)
    return response
}

export const fetchPTBgetApi = queryString => {
    const URL = `${DOMAIN}${appPrefix}/ptb/coupons?${queryString}`
    const response = apiGetHelper(URL, 'application/json; charset=utf-8')
    return response
}

export const userStateApi = userId => {
    const URL = `${DOMAIN}${appPrefix}/workplus/user/state?userId=${userId}`
    const response = apiGetHelper(URL)
    return response
}

export const flightInitiateBookingPostApi = payload => {
    const URL = `${DOMAIN}${appPrefix}/flights/initiate-booking`
    const response = apiPostFormHelper(URL, payload)
    return response
}

export const flightNewInitiateBookingPostApi = payload => {
    const URL = `${DOMAIN}/itin/itinerary/create`
    const response = apiPostHelper(URL, payload, 'application/json')
    return response
}

export const fetchAncillariesData = itinId => {
    const URL = `${DOMAIN}/itin/v1/${itinId}/ancillaries/fetch?includeBaggage=true&includeMeal=true&includeSeat=true`
    const response = apiGetHelper(URL)
    return response
}

export const putAncillariesData = (itinId, payload) => {
    const URL = `${DOMAIN}/itin/v1/${itinId}/ancillaries/update`
    const response = apiPutHelper(URL, payload, 'application/json')
    return response
}

export const deleteAncillariesData = itinId => {
    const URL = `${DOMAIN}/itin/v1/${itinId}/ancillaries/remove-all`
    const response = apiDeleteHelper(URL)
    return response
}

export const flightFreeBaggagePostApi = payload => {
    const URL = `${DOMAIN}${appPrefix}/flights/freeBaggageInfo`
    const response = apiPostHelper(URL, payload)
    return response
}

export const flightAddShortlistPostApi = payload => {
    const URL = `${DOMAIN}${appPrefix}/flight/shortlist/add`
    const response = apiPostHelper(URL, payload, 'application/json')
    return response
}

export const flightRemoveShortlistPostApi = payload => {
    const URL = `${DOMAIN}${appPrefix}/flight/shortlist/delete`
    const response = apiPostHelper(URL, payload, 'application/json')
    return response
}

export const fetchShortListPostApi = payload => {
    const URL = `${DOMAIN}${appPrefix}/flight/shortlist/fetch/entity`
    const response = apiPostHelper(URL, payload, 'application/json')
    return response
}

//TODO: need to chnage the domain - used for local purpose
export const flightFareMiniRulePostApi = payload => {
    // const URL = 'http://localhost:3000/miniResponse.json'
    //const response = apiGetHelper(URL)
    // TODO Abhishek - Make the domain= dynamic
    const URL = `${DOMAIN}${appPrefix}/flights/getminirule?domain=${HOSTNAME}`
    const response = apiPostHelper(URL, payload)
    return response
}

export const flightCorpFareMiniRulePostApi = payload => {
    const URL = `${DOMAIN}/flights/getminirule?domain=${HOSTNAME}&corp=true`
    const response = apiPostHelper(URL, payload)
    return response
}

export async function getDateTabFares(requestParams) {
    try {
        const URL = `${DOMAIN}/flights/flexisearchV2`
        const PAYLOAD = requestParams
        const response = await apiPostHelper(URL, PAYLOAD, 'application/json')
        return response
    } catch (e) {
        logError(e)
        return e
    }
}

export const getAbTestConfig = queryParam => {
    if (CT_ENV !== 'development') {
        const URL = `${DOMAIN}/node/flight/search/ab`
        const response = apiGetHelper(URL)
        return response
    }
}

export const fetchTransitVisaPostApi = payload => {
    const URL = `${DOMAIN}${appPrefix}/flights/transitvisa`
    const response = apiPostHelper(URL, payload, 'application/json; charset=UTF-8')
    return response
}
export const fetchItineary = itineraryId => {
    //oneway const URL = `https://api.myjson.com/bins/x6sso`
    //const URL = `https://api.myjson.com/bins/16d4rs`
    //const URL = `https://api.myjson.com/bins/vi7gw`
    //const URL = 'http://localhost:3000/twoway.json'
    const URL = `${DOMAIN}/itin/itinerary/${itineraryId}`

    const response = apiGetHelper(URL)
    //const response = apiPostHelper(URL, payload, 'application/json; charset=UTF-8')
    return response
}
export const itineraryUpdateApi = payload => {
    const URL = `${DOMAIN}/itin/itinerary/update`

    const response = apiPostHelper(URL, payload, 'application/json')
    return response
}
export const itineraryCashBackApi = (payload, userId) => {
    const URL = `${DOMAIN}${appPrefix}/workplus/cashback?userId=${userId}`

    const response = apiPostHelper(URL, payload, 'application/json')
    return response
}

export const validatePaybackUser = payload => {
    let URL = `${DOMAIN}/itin/${payload.itineraryId}/payback/checkAccount`
    const response = apiGetParamsHelper(URL, payload.queryParams, 'application/json')
    return response
}

export const sendPinNotification = (itineraryId, payload) => {
    let URL = `${DOMAIN}/itin/${itineraryId}/payback/forgotPassword`
    const response = apiPostHelper(URL, payload, 'application/json')
    return response
}

export const getBalance = (itineraryId, payload) => {
    let URL = `${DOMAIN}/itin/${itineraryId}/payback/getBalance`
    const response = apiPostHelper(URL, payload, 'application/json')
    return response
}

export const itineraryPrePaymentApi = payload => {
    const URL = `${DOMAIN}/itin/itinerary/${payload.itineraryId}/prepayment`
    const response = apiPostHelper(URL, payload, 'application/json')
    return response
}
export const itineraryConfirmApi = itineraryId => {
    const URL = `${DOMAIN}/itin/itinerary/${itineraryId}/appConfirm`
    const response = apiGetHelper(URL)
    return response
}

export const crossSellApi = () => {
    const url = `${DOMAIN}/offermgmt/cross-sell/B2C_desktop_in.js`
    const response = apiGetHelper(url)
    return response
}

export const flightInfoApi = itineraryId => {
    const URL = `${DOMAIN}/itin/api/itinerary/${itineraryId}/info/flightInfo`
    const response = apiGetHelper(URL)
    return response
}

export const screenshotStep = payload => {
    const URL = `${DOMAIN}/sc_external_api/initiate`
    const response = apiPostHelper(URL, payload)
    return response
}

export const flightMiniRuleApi = itineraryId => {
    const URL = `${DOMAIN}/itin/api/itinerary/${itineraryId}/info/minirules`
    const response = apiGetHelper(URL)
    return response
}
export const getFlightOffer = code => {
    const URL = `https://ui.cltp.co/landing/hotelsoffer/settings/${code}/json.js?v=${Math.floor(
        +new Date() / 3e3
    )}`
    const response = apiGetHelper(URL)
    return response
}
export const getcarausalOffer = itineraryId => {
    const URL = `https://www.cleartrip.com/offermgmt/B2CAir_in.js?v1451305772`
    const response = apiGetHelper(URL)
    return response
}

export const userSignIn = payload => {
    // const URL = `${DOMAIN}${appPrefix}/itinerary/${itineraryData.itineraryId}/user`
    // const URL = '//identity-microservice.cltp.com:9001/signin'
    const URL = `${DOMAIN}/v2/signin`
    // const URL = `${DOMAIN}${appPrefix}/itin/user/signin`
    const requestHeaders = {
        'X-CT-SOURCETYPE': 'web',
        service: window.location.pathname
    }
    const response = apiPostHelper(URL, payload, 'application/json', requestHeaders)
    return response
}

export const userSignUp = payload => {
    let URL = `${DOMAIN}/accounts-api/user/v2/register`
    if (process.env.CT_ENV !== 'production') {
        URL = `${DOMAIN}/user/v2/register`
    }
    const requestHeaders = {
        'x-ct-caller-app': 'web'
    }
    const response = apiPostHelper(URL, payload, 'application/json', requestHeaders)
    return response
}

export const userResetPassword = email => {
    let URL = `${ORIGIN_DOMAIN}/accounts-api/v2/user/resetPassword?email=${email}`
    if (process.env.CT_ENV !== 'production') {
        URL = `${ORIGIN_DOMAIN}/v2/user/resetPassword?email=${email}`
    }
    const response = apiPostHelper(URL)
    return response
}

export const getUserByEmailId = email => {
    let URL = `${ORIGIN_DOMAIN}/accounts-api/people/v2/fetch?domain=${ORIGIN_DOMAIN}&emailId=${email}`
    if (process.env.CT_ENV !== 'production') {
        URL = `${ORIGIN_DOMAIN}/people/v2/fetch?domain=${ORIGIN_DOMAIN}&emailId=${email}`
    }

    const response = apiGetHelper(URL, {})
    return response
}

export const facebookLoginApi = () => {
    const URL = `${ORIGIN_DOMAIN}/account/singly/singly_api?source=web&service=https://cleartrip.com`
    // ${DOMAIN}`
    const response = apiGetHelper(URL)
    return response
}

export const applyCoupon = (payload, itineraryId) => {
    const URL = `${DOMAIN}/itin/itinerary/${itineraryId}/applyCoupon`
    //const URL = 'http://localhost:3000/applyCoupon_error.json'
    //const URL = 'http://localhost:3000/applyCoupon_Sucess.json'
    const response = apiPostHelper(URL, payload, 'application/json')
    return response
}

export const applyVoucher = (payload, itineraryId) => {
    const URL = `${DOMAIN}/itin/itinerary/${itineraryId}/applyVoucher`
    const response = apiPostHelper(URL, payload, 'application/json')
    return response
}

export const applyShukran = payload => {
    const URL = `${DOMAIN}/freqFlyerService/v1/fareKeys/loyaltyRewardsPoint`
    const response = apiPostHelper(URL, payload, 'application/json')
    return response
}

export const createShukranPayload = fares => {
    // const baseFare = pricings.adtt + pricings.chdt + pricings.inftt
    const shukranPayload = {
        fares: [
            {
                fare_key: fares.fareKey,
                price: fares.price,
                fare_breakup: {
                    BF: fares.basePrice,
                    TAX: fares.taxes
                }
            }
        ],
        program_name: 'SHUKRAN'
    }
    return shukranPayload
}
export const setFareAlert = (payload, filterDataContext, currencyContext, searchQueryContext) => {
    const Url = `${DOMAIN}/farealert/create`
    const { email, phoneNo, firstName = '', lastName = '' } = payload
    const lowestPrice = filterDataContext.oneWayPrice.min
    const currency = currencyContext.conversionRate.code

    const preferredDepTimeMap = {
        '0000': '0_8',
        '0800': '8_12',
        '1200': '12_16',
        '1600': '16_20',
        '2000': '20_24'
    }
    let preferredDepTime = filterDataContext.departureTimeFrom[0].selectedValues.map(
        timeId => preferredDepTimeMap[timeId]
    )

    const { from, to, adults, childs, infants, depart_date, return_date } = searchQueryContext
    let journeyType = 'OW'
    let departDate = [depart_date]
    if (return_date) {
        departDate.push(return_date)
        journeyType = 'RT'
    }
    let fromArr = [],
        toArr = []
    fromArr.push(from)
    toArr.push(to)
    if (journeyType === 'RT') {
        fromArr.push(to)
        toArr.push(from)
    }

    const reqObj = {
        alert: {
            email,
            phoneNo,
            channel: 'B2C',
            domain: DOMAIN,
            price: lowestPrice,
            preferredDepTime,
            currency: currency,
            firstName: firstName,
            lastName: lastName,
            clevertapID: process.env.CT_PUBLIC_CLEVERTAP_KEY || ''
        },
        search: {
            from: fromArr,
            to: toArr,
            departDate,
            journeyType,
            adults,
            children: childs,
            infants,
            flyingClass: searchQueryContext.class,
            // TODO Anoop "flyingClass": "E",
            country: DOMAIN_COUNTRY_MAP[DOMAIN] || ''
        }
    }

    return axios.post(Url, reqObj, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=UTF-8, text/html'
        }
    })
}

export const getProfileDetails = () => {
    // const Url = 'http://localhost:7000/profile'
    const Url = `${DOMAIN}/partial/account/profile`
    return axios.get(Url, {
        headers: {
            Accept: 'text/json'
            // Accept: 'application/json',
            // 'Content-Type': 'application/json; charset=UTF-8, text/html'
        }
        // withCredentials: true
    })
}

/*

/workplus/user/update

req = {
  "id": "103794162",
  "userState": "TRIAL",
  "gstin": "22AAAAA0000A1Z5",
  "emailID": "anoop.raveendran@cleartrip.com",
  "gst_holder_name": ""
}

*/

export const updateGstNumberForCfw = (id, emailID, gstin, gst_holder_name) => {
    const Url = `${DOMAIN}/workplus/user/update`
    // return new Promise((resolve, reject) => {
    //     console.log('update GST - ', id, emailID, gstin, gst_holder_name)
    //     setTimeout(() => {
    //         reject()
    //     }, 3000)
    // })
    return axios.put(
        Url,
        {
            id,
            emailID,
            gstin,
            userState: 'TRIAL',
            gst_holder_name
        },
        {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }
    )
}
export const getItineraryOffer = async () => {
    const URL = `${DOMAIN}/offermgmt/B2CAirSearch_dom_rt_IN.js`
    const response = await apiGetHelper(URL)

    return response
}
export const customAbHeader = (payload)=> {
 
    let header = {
        caller: `${DOMAIN}`,
        ...(payload?.type === 'MOBILE' && { 'ab-otp': 'b'}),
    }
    return header
}

export const sendOtpForSignIn = async payload => {
    const URL = `${DOMAIN}/accounts/external-api/otp`
    // console.log(payload)
    // return {
    //     status: 200,
    //     data: {
    //         comm_id: '200',
    //         status: '200',
    //         action: 'SIGN_UP'
    //     }
    // }
    const response = apiPostHelper(URL, payload, 'application/json', customAbHeader(payload))
    return response
}
export const verifyOtpForSignIn = async payload => {
    const URL = `${DOMAIN}/accounts/external-api/otp/verify-action`
    // console.log(payload)
    // return {
    //     status: 200,
    //     data: {
    //         action: 'SIGNUP'
    //     }
    // }
    const response = apiPostHelper(URL, payload, 'application/json', customAbHeader(payload))
    return response
}

export const checkForLinkingNudge = async payload => {
    const URL = `${DOMAIN}/accounts/external-api/otp/verify-action`
    // return {
    //     status: 200,
    //     data: {
    //         action: true
    //     }
    // }
    const response = apiPostHelper(URL, payload, 'application/json', { caller: `${DOMAIN}` })
    return response
}
export const getLinkedEmailsList = async ({ mobileNumber, countryCode }) => {
    const URL = `${DOMAIN}/accounts/external-api/users`
    // console.log(URL)
    // return {
    //     status: 200,
    //     data: {
    //         users: [
    //             {
    //                 id: '123',
    //                 username: 'ashok.chitkara@chitkara.com'
    //             },
    //             {
    //                 id: '12',
    //                 username: 'a@a.com'
    //             },
    //             {
    //                 id: '124',
    //                 username: 'random@api.com'
    //             },
    //             {
    //                 id: '123',
    //                 username: 'as123@123cc.com'
    //             }
    //         ]
    //     }
    // }
    // return {
    //     status: 200,
    //     data: {
    //         users: []
    //     }
    // }
    const response = apiGetHelper(URL, {}, { caller: `${DOMAIN}` })
    return response
}
export const getUserProfileDetails = () => {
    let URL = `${ORIGIN_DOMAIN}/accounts-api/people/v2/fetch/details`
    if (process.env.CT_ENV !== 'production') {
        URL = `${ORIGIN_DOMAIN}/people/v2/fetch/details`
    }

    const response = apiGetHelper(URL, {}, { caller: `${DOMAIN}` })
    return response
}

export const submitPersonalDetails = async payload => {
    let URL = `${DOMAIN}/accounts/external-api/user`
    console.log(payload)

    const response = apiPutHelper(URL, payload, 'application/json', { caller: `${DOMAIN}` })
    return response
}

export const linkAccounts = async payload => {
    let URL = `${DOMAIN}/external-api/user`
    console.log(payload)
    return {
        status: 200
    }

    // const response = apiPutHelper(URL, payload, 'application/json')
    // return response
}

export const saveNudge = async type => {
    let URL = `${DOMAIN}/accounts/external-api/nudge?type=${type}`
    // console.log(payload)
    // return {
    //     status: 200
    // }

    const response = apiPostHelper(URL, null, 'application/json', { caller: `${DOMAIN}` })
    return response
}
export const getUserByMobile = (mobile, countryCode) => {
    let code = encodeURIComponent(countryCode)
    let URL = `${ORIGIN_DOMAIN}/accounts-api/people/v2/fetch?domain=${ORIGIN_DOMAIN}&mobile=${mobile}&countryCode=${code}`
    if (process.env.CT_ENV !== 'production') {
        URL = `${ORIGIN_DOMAIN}/people/v2/fetch?domain=${ORIGIN_DOMAIN}&mobile=${mobile}&countryCode=${code}`
    }

    const response = apiGetHelper(URL, {})
    return response
}

export const personalization = (localStorageDeviceId) => {
    try {
      const URL = `${ORIGIN_DOMAIN}/personalization` // add domain and same in proxy file
      const header = {
        caller: ORIGIN_DOMAIN,
      ...(localStorageDeviceId && { dvid:localStorageDeviceId })
      }
      const response = apiGetHelper(URL,{}, header)
      return response
    } catch (e) {
      console.error(e)
    }
  }